export const URLs = {
    Facebook: "https://www.facebook.com/athelm.tech",
    Twitter: "https://twitter.com/AtHelmTech",
    Pintrest: "https://www.pinterest.com/athelmtech/",
    Instagram: "https://www.instagram.com/athelm.tech/",
    LinkedIN: "https://www.linkedin.com/company/athelm-tech",
}

export const Metrics = {
    MaxYearsExperience: 15,
    CombinedStartUpCount: 10,
    CombinedFundingRaisedInMillion: 400,
}